export default () => {
  // eslint-disable-next-line quotes
  let sourceStr = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G"
  let digit = 15
  let arrStr = sourceStr.split(',')
  let result = '' // 定义变量并初始化
  let index = 0
  for (let i = 0; i < digit; i++) {
    index = parseInt(Math.random() * arrStr.length)
    result += arrStr[index]
  }
  return result
}